import { lazy } from 'react';

export default {
    ProjectList: lazy(() => import("./project/list")),
}